// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import $ from 'jquery';
import 'bootstrap-italia/dist/css/bootstrap-italia.min.css';

import globals from './config/appconfig';
import '../src/css/global.css'

import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import common_en from "./translations/en/common.json";
import common_it from "./translations/it/common.json";

i18next.init({
    interpolation: {escapeValue: false},  // React already does escaping
    lng: globals.lingua_default,                              // language to use
    resources: {
        en: {
            common: common_en               // 'common' is our custom namespace
        },
        it: {
            common: common_it               // 'common' is our custom namespace
        },
    },
});


window.jQuery = $;
window.$ = $;

String.prototype.regexIndexOf = function (regex, startpos) {
    var indexOf = this.substring(startpos || 0).search(regex)
    return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf
}

ReactDOM.render(
    <BrowserRouter>
        <I18nextProvider i18n={i18next}>
            <App/>
        </I18nextProvider>

    </BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
